







exports.default =
  data: ->
    show_preview: false

  props:
    item: { required: true }
    searchText: { required: true }
  
  components:
    templatePreview: require('../../templates/preview.vue')

  methods:
    replacer: (match) ->
      '<strong>'+match+'</strong>'

    showPreview: ->
      @show_preview = !@show_preview
      EventsBus.$emit 'TemplateAutoComplete::SetShowList', true, @$parent.$parent._uid

  computed:
    text: ->
      @item?.name?.replace(new RegExp(@searchText, "i"), @replacer)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/shared/autocomplete/template_item.vue